<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Modifier un animal"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-row>
            <b-col>
              <b-form-group
                id="name-input"
                label="Nom *"
                label-for="name-input"
                class="bold-label"
                :invalid-feedback="form.name.invalidFeedback"
                :state="form.name.state"
              >
                <b-form-input
                  id="name-input"
                  v-model="form.name.value"
                  type="text"
                  maxlength="250"
                  :state="form.name.state"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="species-select"
                label="Espèce *"
                label-for="species-select"
                class="bold-label"
                :invalid-feedback="form.species.invalidFeedback"
                :state="form.species.state"
              >
                <b-form-select
                  id="species-select"
                  v-model="form.species.value"
                  :options="speciesOptions"
                  :state="form.species.state"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="user-select"
                label="Propriétaire *"
                label-for="user-select"
                class="bold-label"
                :invalid-feedback="form.user.invalidFeedback"
                :state="form.user.state"
              >
                <AutoCompleteInput
                  id="user-select"
                  placeholder="Sélectionner un propriétaire"
                  :options="usersOptions"
                  :initValue="form.user"
                  @didSelect="(value) => form.user.value = value"
                  @onReset="userSelectInvalid = false"
                  :invalid="userSelectInvalid"
                  invalid-message="Vous devez sélectionner un propriétaire"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Date de naissance"
                label-for="startDateCal"
                class="bold-label"
                :description="'Format : ' + new Date().toLocaleDateString('fr-FR')"
                :invalid-feedback="form.user.invalidFeedback"
                :state="form.user.state"
              >
                <vc-date-picker
                  ref="startDateCal"
                  v-model="form.dateOfBirth.value"
                  mode="date"
                  color="orange"
                  :popover="{ visibility: 'click' }"
                  :first-day-of-week="2"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="border px-2 py-1 rounded birth-datepicker"
                      :class="{'is-invalid': form.dateOfBirth.state === false}"
                      :value="inputValue"
                      v-on="inputEvents"
                      placeholder="Date de début"
                    />
                  </template>
                </vc-date-picker>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Modifier animal</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

    import api from '../../services/api';
    import BackArrow from "../../components/BackArrow";
    import AutoCompleteInput from "../../components/AutoCompleteInput";

    export default {

        name: 'AnimalEdit',

        components: {
          BackArrow,
          AutoCompleteInput
        },

        data() {
            return {
                form: {
                    name: {
                        state: null,
                        invalidFeedback: null,
                        value: null
                    },
                    species: {
                        state: null,
                        invalidFeedback: null,
                        value: null
                    },
                    user:{
                        state: null,
                        invalidFeedback: null,
                        value: null
                    },
                    dateOfBirth:{
                        state:null,
                        invalidFeedback: null,
                        value: null
                    }
                },
                speciesOptions: [
                    { value: null, text: 'Sélectionner une espèce' },
                ],
                usersOptions: [
                    { value: null, text: 'Sélectionner un propriétaire' },
                ],
                animalId: this.$route.params.animalId,
                animal : null,
                userSelectInvalid: false,
                sendButtonDisabled: false,
            }
        },

        mounted(){
            this.fetchAnimal();
            this.fetchUsers();
            this.fetchSpecies();
        },

        methods: {

            fetchAnimal(){
                api
                  .get(`/animal/${this.animalId}`)
                  .then(response => {
                     this.animal = response.data
                     this.setInitialValues()
                })
            },

            setInitialValues() {
                this.form.name.value = this.animal.name
                this.form.species.value = this.animal.species.id
                this.form.user.value = this.animal.user.id
                if(this.animal.dateOfBirth != null) this.form.dateOfBirth.value = this.animal.dateOfBirth
            },

            fetchUsers(){
                api
                    .get(`/user`)
                    .then(response => {
                        response.data.forEach(
                            (element) => {
                                this.usersOptions.push({value: element.id, text: `${element.firstName} ${element.lastName}`})
                            }
                        )
                    })
            },
            fetchSpecies(){
                api
                    .get(`/species`)
                    .then(response => {
                        response.data.forEach(
                            (element) => {
                                this.speciesOptions.push({value: element.id, text: element.name})
                            }
                        )
                    })
            },
            onSubmit() {
                if(this.form.user.value === null){
                  this.userSelectInvalid = true
                  return
                }
                this.sendButtonDisabled = true

                let birthday = new Date(this.form.dateOfBirth.value).getTime()

                let data = new FormData()
                data.append('name', this.form.name.value)
                data.append('speciesId', this.form.species.value)
                data.append('userId', this.form.user.value)
                if(birthday !== 0) data.append('dateOfBirth', birthday.toString())

                api({
                    method: 'POST',
                    url: `/animal/${this.animal.id}`,
                    data: data
                })
                    .then((response) => {
                        this.$router.push({
                            name: 'AnimalShow',
                            params: {
                                animalId: this.animal.id
                            }
                        }, () => {
                            this.$nextTick(() => {
                                this.successToast(this.form.name.value)
                            })
                        })
                    })
                    .catch((error) => {
                      this.sendButtonDisabled = false
                        if (error.response.status === 418) {
                            const invalidField = error.response.data.invalidField
                            this.form[invalidField]["state"] = false
                            this.form[invalidField]["invalidFeedback"] = error.response.data.message
                        }
                    });
            },

            successToast(animalName) {
                this.$bvToast.toast(`Animal \"${animalName}\" modifié`, {
                    autoHideDelay: 2000,
                    toaster: 'b-toaster-bottom-right',
                    noCloseButton: true
                })
            }
        }
    }
</script>

<style scoped>
  .birth-datepicker {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--main-text-color);
    height: calc(1.5em + 0.75rem + 2px);
    border: 1px solid var(--neutral-300) !important;
    border-radius: 0.25rem;
    width: 100%;
  }
  .birth-datepicker.is-invalid {
    border: solid var(--main-red) 1px !important;
    padding-right: calc(0.75em + 2.3125rem) !important;
    background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23767676' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, var(--main-white) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F4464F' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F4464F' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat
  }
</style>



// WEBPACK FOOTER //
// src/views/animal/AnimalEdit.vue